import type { BackendRouteDefinition } from '../types';
import type { SendEmployeePasswordResetLink } from '@cloudFunctions/types/firms/sendEmployeePasswordResetLink';
import { withIdempotencyKeyHeader } from '../../../../../shared/backend/routes/idempotency';
import { buildDeterministicIdempotencyKey } from './buildDeterministicIdempotencyKey';

// Flipped from `transport: 'callable'` to `transport: 'api'` by S6-WB2
// (PRA-795). Now served by `api-core-node` at
// `POST /api/public/employees/password-resets`.
//
// Public-invoker: the forgot-password page is shown before the user has
// signed in, so the api-core-node route is registered with `auth: off`
// (same as the legacy callable, which did not verify auth either).
// Idempotency uses a 30-second completed window to throttle accidental
// double-clicks while still allowing a deliberate retry a minute later.
export const sendEmployeePasswordResetLinkRoute = {
  transport: 'api',
  method: 'POST',
  path: '/public/employees/password-resets',
  body: (requestData: SendEmployeePasswordResetLink.Props) => requestData,
  headers: (requestData: SendEmployeePasswordResetLink.Props) =>
    withIdempotencyKeyHeader({
      idempotencyKey: buildDeterministicIdempotencyKey({
        prefix: 'send-employee-password-reset',
        requestData,
      }),
    }),
} as const satisfies BackendRouteDefinition;
